var $enableFormatPrices = false;
function formatPrices($container) {
    if (!$enableFormatPrices) return;
    if (!$container || $container.length < 0) $container = $('html');
    var $boxes = $('[data-format="price"]:not(.price-formatted)', $container);
    $boxes.each(function (index, box) {
        var $box = $(box), amount = $box.html(), formed = "";
        if ($box.hasClass('price-formatted')) return;
        $box.addClass('price-formatted');
        formed = formatPrice(amount);
        $box.html(formed);
    });
    return $boxes.length;
}

function formatPrice(amount) {
    var sep = LhApp.Context.Currency.DecimalSeparator, cur = decodeEntities(LhApp.Context.Currency.Symbol), pos, formed = "";
    if (!amount) return formed;
    amount = amount.trim();
    pos = amount.indexOf(cur);
    amount = amount.replace(cur, '').trim().split(sep);

    /* Respect number of decimal digits */
    amount[1] = amount[1].substring(0, LhApp.Context.Currency.NumberOfDigits);

    formed += pos == 0 ? '<span class="currency-symbol">' + cur + '</span>' : '';
    formed += amount.length > 0 ? '<span class="integer-part">' + amount[0] + '</span>' : '';
    /* Hides decimal part */
    if (amount[1] == '00') {
        formed += amount.length > 1 ? '<span class="sep no-decimal">' + sep + '</span><span class="decimal-part no-decimal">' + amount[1] + '</span>' : '';
    } else {
        formed += amount.length > 1 ? '<span class="sep">' + sep + '</span><span class="decimal-part">' + amount[1] + '</span>' : '';
    }
    formed += pos > 0 ? '<span class="currency-symbol">' + cur + '</span>' : '';
    return formed;
}